// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".prefix[data-v-6362de20]{font-size:2em;height:100%;line-height:1.2em;color:#606266}", ""]);
// Exports
module.exports = exports;
